import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { resources } from "./resources";

/**
 * i18next mínimo, con la misma configuración de detección que el sistema
 * actual para que los componentes migrados (`useTranslation`) funcionen sin
 * cambios.
 *
 * OJO: NO pasar `lng` en init. Fijar `lng` anula por completo al
 * LanguageDetector — ese fue el bug del sistema viejo, donde todo el mundo
 * veía español aunque su navegador estuviera en inglés.
 */
if (!i18n.isInitialized) {
  void i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      fallbackLng: "es",
      supportedLngs: ["es", "en"],
      debug: false,
      // Claves = frases en español (con puntos, comas, ¿?) → no las trates
      // como rutas anidadas.
      keySeparator: false,
      nsSeparator: false,
      defaultNS: "translation",
      interpolation: { escapeValue: false },
      returnEmptyString: false,
      resources,
      detection: {
        // `querystring` primero (?lang=en en links compartidos), luego la
        // elección manual guardada, y al final el idioma del navegador.
        order: ["querystring", "localStorage", "navigator"],
        lookupQuerystring: "lang",
        lookupLocalStorage: "user_language_preference",
        caches: ["localStorage"],
      },
    });
}

/**
 * `<html lang>` sigue al idioma activo.
 *
 * `index.html` lo deja escrito en "es" y hasta ahora eso bastaba: no
 * había forma de cambiar de idioma en ninguna pantalla, así que el
 * atributo nunca se quedaba desfasado. Con el selector de la barra
 * superior sí: alguien pone la interfaz en inglés y el documento sigue
 * declarándose español, así que un lector de pantalla lee "Create
 * account" con la voz y las reglas de pronunciación del español. También
 * afecta a la partición de palabras y a las comillas tipográficas.
 *
 * Va aquí y no en el selector a propósito: el idioma también lo fija el
 * detector al arrancar (`?lang=en`, la preferencia guardada, el
 * navegador), y el atributo tiene que seguirlo venga de donde venga.
 */
function syncDocumentLanguage(language: string): void {
  if (typeof document === "undefined") return;
  document.documentElement.lang = language;
}

syncDocumentLanguage(i18n.resolvedLanguage ?? "es");
i18n.on("languageChanged", (language) => {
  syncDocumentLanguage(i18n.resolvedLanguage ?? language);
});

export default i18n;
